var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_2418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64863 18.1294L5.60437 22.0278L1.78764 22.1085C0.646992 19.9929 0 17.5723 0 15C0 12.5127 0.604922 10.1671 1.67719 8.10168H1.67801L5.07598 8.72465L6.56449 12.1022C6.25295 13.0105 6.08314 13.9855 6.08314 15C6.08326 16.1011 6.28271 17.1561 6.64863 18.1294Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7379 12.1978C29.9101 13.1051 29.9999 14.0422 29.9999 14.9999C29.9999 16.0738 29.887 17.1214 29.6719 18.1318C28.9417 21.5703 27.0338 24.5728 24.3907 26.6975L24.3898 26.6967L20.1099 26.4783L19.5042 22.6969C21.258 21.6684 22.6286 20.0587 23.3506 18.1318H15.3297V12.1978H23.4676H29.7379Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3898 26.6967L24.3906 26.6975C21.82 28.7637 18.5546 30 15 30C9.2876 30 4.32113 26.8071 1.7876 22.1085L6.64859 18.1294C7.91533 21.5101 11.1766 23.9168 15 23.9168C16.6433 23.9168 18.1829 23.4725 19.5041 22.697L24.3898 26.6967Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5745 3.45328L19.7152 7.43156C18.3479 6.57691 16.7316 6.0832 15.0001 6.0832C11.0902 6.0832 7.76789 8.60021 6.56461 12.1022L1.67807 8.10164H1.67725C4.17369 3.28846 9.20279 0 15.0001 0C18.6396 0 21.9767 1.29645 24.5745 3.45328Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_2418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleImg);
export default __webpack_public_path__ + "static/media/google-img.96c383b9074a40aad98c596dda2f4409.svg";
export { ForwardRef as ReactComponent };